// KeenSliderの読み込み
import KeenSlider from "keen-slider";

// ----------------------------------------
// メインビジュアルスライダー
// ----------------------------------------
const initHeroSlider = () => {
    const heroSliderElement = document.querySelector("#heroSlider");
    if (!heroSliderElement) return;

    const animation = { duration: 60000, easing: (t) => t };

    return new KeenSlider(heroSliderElement, {
        loop: true,
        renderMode: "performance",
        drag: false,
        slides: {
            perView: 2.5,
            spacing: 40,
        },
        created: (s) => s.moveToIdx(5, true, animation),
        updated: (s) => s.moveToIdx(s.track.details.abs + 5, true, animation),
        animationEnded: (s) => s.moveToIdx(s.track.details.abs + 5, true, animation),
    });
};

// ----------------------------------------
// モバイルメインビジュアルスライダー
// ----------------------------------------
const initHeroSliderMobile = () => {
    const heroSliderMobileElement = document.querySelector("#heroSliderMobile");
    if (!heroSliderMobileElement) return;

    const animation = { duration: 20000, easing: (t) => t };

    return new KeenSlider(heroSliderMobileElement, {
        loop: true,
        mode: "snap",
        slides: {
            origin: "center",
            perView: 1,
            spacing: 16,
        },
        created: (s) => {
            s.moveToIdx(1, true, animation);
        },
        updated: (s) => {
            s.moveToIdx(s.track.details.abs + 1, true, animation);
        },
        animationEnded: (s) => {
            s.moveToIdx(s.track.details.abs + 1, true, animation);
        },
    });
};

// ----------------------------------------
// インタビュースライダー
// ----------------------------------------
const initInterviewSlider = () => {
    const interviewSliderElement = document.querySelector(".p-employee-intro__slider");
    if (!interviewSliderElement) return;

    const slides = interviewSliderElement.querySelectorAll(".keen-slider__slide");
    const isMobile = window.innerWidth <= 767;
    if ((isMobile && slides.length <= 1) || (!isMobile && slides.length <= 3)) {
        interviewSliderElement.classList.add("static-slider");
        return;
    }

    const handleAutoplay = (slider) => {
        let timeout;
        let mouseOver = false;

        const clearNextTimeout = () => clearTimeout(timeout);

        const nextTimeout = () => {
            clearTimeout(timeout);
            if (mouseOver) return;
            timeout = setTimeout(() => slider.next(), 2500);
        };

        slider.on("created", () => {
            slider.container.addEventListener("mouseover", () => {
                mouseOver = true;
                clearNextTimeout();
            });
            slider.container.addEventListener("mouseout", () => {
                mouseOver = false;
                nextTimeout();
            });
            nextTimeout();
        });

        slider.on("dragStarted", clearNextTimeout);
        slider.on("animationEnded", nextTimeout);
        slider.on("updated", nextTimeout);
    };

    return new KeenSlider(".p-employee-intro__slider", {
        loop: true,
        mode: "snap",
        slides: {
            perView: 3.5,  // デフォルト値（PC用）
            spacing: 16,
        },
        breakpoints: {
            "(max-width: 767px)": {
                slides: { perView: 6, spacing: 16 }  // スマートフォン
            },
            "(min-width: 768px) and (max-width: 1024px)": {
                slides: { perView: 4, spacing: 16 }  // タブレット
            }
        }
    }, [handleAutoplay]);
};

// ----------------------------------------
// 採用情報スライダー
// ----------------------------------------
const initRecruitSlider = () => {
    const sliderWrapper = document.querySelector(".p-top-recruit__slider-wrapper");
    if (!sliderWrapper) return;

    const slides = Array.from(sliderWrapper.children);
    slides.forEach(slide => {
        const clone = slide.cloneNode(true);
        sliderWrapper.appendChild(clone);
    });

    let scrollAmount = 0;
    const speed = 0.5;

    const animateSlider = () => {
        scrollAmount += speed;
        if (scrollAmount >= sliderWrapper.scrollWidth / 2) {
            scrollAmount = 0;
        }
        sliderWrapper.scrollLeft = scrollAmount;
        requestAnimationFrame(animateSlider);
    };

    animateSlider();
};

// 初期化
document.addEventListener("DOMContentLoaded", () => {
    initHeroSlider();
    initHeroSliderMobile();
    initInterviewSlider();
    initRecruitSlider();
});
